import { OverlayScrollbarsComponentRef } from 'overlayscrollbars-react';

export const getContainerElementFromOverlayScrollbarsRef = (
  ref: React.RefObject<OverlayScrollbarsComponentRef<'div'>>
) => ref.current?.osInstance()?.elements().viewport || null;
